import React from 'react';
import { useProjectContext } from '@atlassian/jira-providers-project-context';
import { APP_NAMES } from '@atlassian/jira-servicedesk-common/src/utils/app-names';
import { JsdGettingStartedPanelShouldRender } from '@atlassian/jira-servicedesk-getting-started-panel/src/async';
import PortalSettings from '@atlassian/jira-servicedesk-portal-settings/src/ui/index.tsx';
import ServiceDeskAppBase from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/app-base/index.tsx';
import { ServiceDeskDocumentTitle } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/document-title/index.tsx';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment';
import { Redirect } from '@atlassian/react-resource-router';

const ClassicPortalSettings = () => {
	const { data: projectContext } = useProjectContext();
	// if next-gen project: redirect to /jira/servicedesk/projects/:projectKey/settings/channels/portal-settings
	if (projectContext?.simplified) {
		return (
			<Redirect
				to={`/jira/servicedesk/projects/${projectContext.projectKey}/settings/channels/portal-settings`}
			/>
		);
	}

	return (
		<UFOSegment name="portal-settings">
			<MarkProductStart />
			<ServiceDeskAppBase appName={APP_NAMES.PORTAL_SETTINGS}>
				{projectContext && (
					<>
						<ServiceDeskDocumentTitle
							projectName={projectContext.projectName}
							section="portalSettings"
						/>
						<PortalSettings
							isAdmin={projectContext.isProjectAdmin || false}
							isProjectSimplified={projectContext.simplified}
							projectId={projectContext.projectId}
							projectKey={projectContext.projectKey}
							projectName={projectContext.projectName}
						/>
					</>
				)}
			</ServiceDeskAppBase>
			<JsdGettingStartedPanelShouldRender />
		</UFOSegment>
	);
};

export default ClassicPortalSettings;
